const as = {
    "gui.menuBar.file": "ফাইল",
    "gui.menuBar.edit": "সম্পাদনা কৰক",
    "gui.menuBar.new": "নতুন",
    "gui.menuBar.saveNow": "এতিয়া সংৰক্ষণ কৰক",
    "gui.menuBar.saveAsCopy": "প্ৰতিলিপি হিচাপে সংৰক্ষণ কৰক",
    "gui.menuBar.remix": "ৰিমিক্স",
    "gui.menuBar.languageSelector": "ভাষা নিৰ্বাচক",
    "gui.menuBar.tutorialsLibrary": "টিউটোৰিয়েল",
    "gui.menuBar.community": "সম্প্ৰদায়",
    "gui.menuBar.wiki": "ডাউনলোড এজেন্ট",
    "gui.menuBar.restoreSprite": "স্প্ৰাইট পুনৰুদ্ধাৰ কৰক",
    "gui.menuBar.restoreSound": "শব্দ পুনৰুদ্ধাৰ কৰক",
    "gui.menuBar.restoreCostume": "পোছাক পুনৰুদ্ধাৰ কৰক",
    "gui.menuBar.restore": "পুনৰুদ্ধাৰ কৰক",
    "gui.menuBar.turboModeOff": "টাৰ্বো মোড বন্ধ কৰক",
    "gui.menuBar.turboModeOn": "টাৰ্বো মোড চালু কৰক",
    "gui.menuBar.noDeviceSelected": "কোনো ডিভাইচ নিৰ্বাচিত নহয়",
    "gui.menuBar.noConnection": "সংযোগ নাই",
    "gui.menuBar.downloadToComputer": "আপোনাৰ কম্পিউটাৰত সংৰক্ষণ কৰক",
    "gui.menuBar.checkUpdate": "আপডেট পৰীক্ষা কৰক",
    "gui.menuBar.installDriver": "ড্ৰাইভাৰ ইনষ্টল কৰক",
    "gui.menuBar.clearCacheAndRestart": "কেশ্ব পৰিষ্কাৰ কৰক আৰু পুনৰাৰম্ভ কৰক",
    "gui.alerts.createsuccess": "নতুন প্ৰকল্প সৃষ্টি কৰা হৈছে।",
    "gui.alerts.createcopysuccess":
        "প্ৰকল্প প্ৰতিলিপি হিচাপে সংৰক্ষণ কৰা হৈছে।",
    "gui.alerts.createremixsuccess": "প্ৰকল্প ৰিমিক্স হিচাপে সংৰক্ষণ কৰা হৈছে।",
    "gui.alerts.creating": "নতুন সৃষ্টি কৰি আছে...",
    "gui.alerts.creatingCopy": "প্ৰকল্পৰ প্ৰতিলিপি সৃষ্টি কৰি আছে...",
    "gui.alerts.creatingRemix": "প্ৰকল্পৰ ৰিমিক্স সৃষ্টি কৰি আছে...",
    "gui.alerts.downloading": "ডাউনলোড কৰি আছে...",
    "gui.alerts.loading": "লোড কৰি আছে...",
    "gui.alerts.saving": "সংৰক্ষণ কৰি আছে...",
    "gui.alerts.savesuccess": "প্ৰকল্প সংৰক্ষণ কৰা হৈছে।",
    "gui.alerts.savingError": "প্ৰকল্প সংৰক্ষণ কৰিব পৰা নগ'ল।",
    "gui.gui.addExtension": "সম্প্ৰসাৰণ যোগ কৰক",
    "gui.gui.code": "ক'ড",
    "gui.gui.backdrops": "পটভূমি",
    "gui.gui.costumes": "পোছাক",
    "gui.gui.sounds": "শব্দ",
    "gui.gui.codeTab": "ক'ড",
    "gui.gui.costumesTab": "পোছাক",
    "gui.gui.backdropsTab": "পটভূমি",
    "gui.gui.soundsTab": "শব্দ",
    "gui.library.filterPlaceholder": "সন্ধান কৰক",
    "gui.library.allTag": "সকলো",
    "gui.library.readMore": "অধিক জানক",
    "gui.library.readLess": "কম জানক",
    "gui.loader.headline": "প্ৰকল্প লোড কৰি আছে",
    "gui.loader.creating": "প্ৰকল্প সৃষ্টি কৰি আছে",
    "gui.spriteLibrary.chooseASprite": "স্প্ৰাইট নিৰ্বাচন কৰক",
    "gui.spriteLibrary.paintASprite": "আঁকক",
    "gui.spriteLibrary.uploadASprite": "স্প্ৰাইট আপলোড কৰক",
    "gui.spriteLibrary.surprise": "আচৰিত",
    "gui.soundLibrary.chooseASound": "শব্দ নিৰ্বাচন কৰক",
    "gui.soundLibrary.record": "ৰেকৰ্ড",
    "gui.soundLibrary.uploadASound": "শব্দ আপলোড কৰক",
    "gui.costumeLibrary.chooseACostume": "পোছাক নিৰ্বাচন কৰক",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "কেমেৰা বন্ধ কৰক",
    "gui.menu-bar.realtimeMode": "স্ক্র্যাচ",
    "gui.menu-bar.programMode": "প্ৰোগ্ৰাম",
    "gui.extensionLibrary.comingSoon": "শীঘ্ৰে আহি আছে",
    "gui.extensionLibrary.requires": "প্ৰয়োজন",
    "gui.extensionLibrary.collaboration": "সহযোগিতাত",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "নিৰ্মাতা",
    "gui.extensionLibrary.version": "সংস্কৰণ",
    "gui.extensionLibrary.author": "লেখক",
    "gui.extensionLibrary.programMode": "প্ৰোগ্ৰাম মোড",
    "gui.extensionLibrary.programLanguage": "প্ৰোগ্ৰাম ভাষা",
    "gui.extensionLibrary.deviceLearnMore": "অধিক জানক",
    "gui.extensionLibrary.extensionHelp": "সহায়",
    "gui.extensionLibrary.Processing": "প্ৰক্ৰিয়াকৰণ চলি আছে...",
    "gui.extensionLibrary.loaded": "লোড কৰা হৈছে",
    "gui.extensionLibrary.notLoaded": "লোড কৰা হোৱা নাই",
    "gui.extensionLibrary.chooseAnExtension": "এটা এক্সটেনচন নিৰ্বাচন কৰক",
    "gui.hardwareHeader.upload": "অপলোড কৰক",
    "gui.costumeLibrary.paintACostume": "আঁকক",
    "gui.costumeLibrary.uploadACostume": "পোছাক আপলোড কৰক",
    "gui.backdropLibrary.chooseABackdrop": "পটভূমি নিৰ্বাচন কৰক",
    "gui.backdropLibrary.paintABackdrop": "আঁকক",
    "gui.backdropLibrary.uploadABackdrop": "পটভূমি আপলোড কৰক",
    "gui.stageSelector.stage": "মঞ্চ",
    "gui.stageSelector.backdrops": "পটভূমি",
    "gui.spriteSelectorItem.contextMenuDuplicate": "প্ৰতিলিপি কৰক",
    "gui.spriteSelectorItem.contextMenuExport": "ৰপ্তানি কৰক",
    "gui.spriteSelectorItem.contextMenuDelete": "মচক",
    "gui.spriteInfo.sprite": "স্প্ৰাইট",
    "gui.spriteInfo.size": "আকাৰ",
    "gui.spriteInfo.show": "দেখুৱাওক",
    "gui.spriteInfo.direction": "দিশ",
    "gui.deviceLibrary.chooseADevice": "ডিভাইচ নিৰ্বাচন কৰক",
    "gui.playButton.play": "চলাওক",
    "gui.playButton.stop": "বন্ধ কৰক",
    "gui.gui.variablePromptDefaultValue": "মোৰ চলক",
    "gui.gui.listVariable": "তালিকা সৃষ্টি কৰক",
    "gui.gui.makeAVariable": "চলক সৃষ্টি কৰক",
    "gui.gui.newVariable": "নতুন চলক",
    "gui.soundEditor.sound": "শব্দ",
    "gui.soundEditor.play": "চলাওক",
    "gui.soundEditor.stop": "বন্ধ কৰক",
    "gui.soundEditor.copy": "প্ৰতিলিপি",
    "gui.soundEditor.paste": "পেষ্ট",
    "gui.soundEditor.delete": "মচক",
    "gui.soundEditor.save": "সংৰক্ষণ কৰক",
    "gui.soundEditor.undo": "পূৰ্বৱত কৰক",
    "gui.soundEditor.redo": "পুনৰ কৰক",
    "paint.paintEditor.hue": "ৰং",
    "paint.paintEditor.saturation": "সংপৃক্তি",
    "paint.paintEditor.brightness": "উজ্জ্বলতা",
    "paint.paintEditor.fill": "পূৰণ কৰক",
    "paint.paintEditor.costume": "পোছাক",
    "paint.paintEditor.group": "গোট",
    "paint.paintEditor.ungroup": "গোট বাতিল কৰক",
    "paint.paintEditor.undo": "পূৰ্বৱত কৰক",
    "paint.paintEditor.redo": "পুনৰ কৰক",
    "paint.paintEditor.more": "অধিক",
    "paint.modeTools.copy": "প্ৰতিলিপি",
    "paint.modeTools.paste": "পেষ্ট",
    "paint.modeTools.delete": "মচক",
    "paint.brushMode.brush": "ব্ৰাছ",
    "paint.eraserMode.eraser": "মচনী",
    "paint.fillMode.fill": "পূৰণ কৰক",
    "paint.lineMode.line": "ৰেখা",
    "paint.ovalMode.oval": "বৃত্ত",
    "paint.rectMode.rect": "আয়ত",
    "paint.selectMode.select": "নিৰ্বাচন কৰক",
    "paint.textMode.text": "পাঠ",
    "gui.connection.connect": "সংযোগ কৰক",
    "gui.connection.disconnect": "সংযোগ বিচ্ছিন্ন কৰক",
    "gui.connection.connected": "সংযুক্ত",
    "gui.connection.connecting": "সংযোগ কৰি আছে...",
    "gui.connection.error": "ত্ৰুটি",
    "blockly.deleteBlock": "ব্লক মচক",
    "blockly.duplicateBlock": "প্ৰতিলিপি কৰক",
    "blockly.addComment": "মন্তব্য যোগ কৰক",
    "blockly.removeComment": "মন্তব্য আঁতৰাওক",
    "blockly.help": "সহায়",
    "blockly.undo": "পূৰ্বৱত কৰক",
    "blockly.redo": "পুনৰ কৰক",

    // Device translations
    "gui.device.unselectDevice.name": "ডিভাইচ নিৰ্বাচন বাতিল কৰক",
    "gui.device.unselectDevice.description":
        "ডিভাইচ নিৰ্বাচন বাতিল কৰক, বিশুদ্ধ ৰিয়েলটাইম প্ৰগ্ৰামিং মোডলৈ ঘূৰি যাওক।",
    "gui.device.connectingMessage": "সংযোগ কৰি আছে",
    "gui.device.arduinoUno.description":
        "ইলেক্ট্ৰনিক্স আৰু ক'ডিংৰ সৈতে আৰম্ভ কৰিবলৈ এটা উত্তম বৰ্ড।",
    "gui.device.arduinoNano.description":
        "Arduino Nano আপোনাৰ প্ৰকল্পসমূহ নিৰ্মাণ কৰিবলৈ এটা ক্লাছিক সৰু বৰ্ড।",
    "gui.device.arduinoLeonardo.description":
        "ক্লাছিক Arduino বৰ্ড যি মাউছ বা কীব'ৰ্ড হিচাপে কাম কৰিব পাৰে।",
    "gui.device.arduinoMega2560.description":
        "54 ডিজিটেল পিন, 16 এনাল'গ ইনপুট আৰু 4 চিৰিয়েল প'ৰ্ট থকা 8-বিট বৰ্ড।",
    "gui.device.arduinoUnoR4Minima.description":
        "উন্নত প্ৰদৰ্শন আৰু সম্প্ৰসাৰিত মেম'ৰি প্ৰদান কৰে, বৰ্তমানৰ শ্বিল্ড আৰু এক্সেচৰিজৰ সৈতে সামঞ্জস্যতা বজাই ৰাখে।",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi আৰু Bluetooth সংযোগ প্ৰদান কৰে, লগতে ভিজুৱেলাইজেশ্বনৰ বাবে অন-ব'ৰ্ড 12x8 LED মেট্ৰিক্স।",
    "gui.device.esp32.description":
        "সমৃদ্ধ কাৰ্যসমূহৰ সৈতে Wi-Fi আৰু Bluetooth নিয়ন্ত্ৰণ বৰ্ড।",
    "gui.device.esp32S3.description":
        "দক্ষ, কম-শক্তি IoT এজ আৰু AI ৱৰ্কল'ডৰ বাবে সমৰ্পিত AI এক্সেলাৰেটৰ আৰু সমৃদ্ধ পেৰিফেৰেল চেট একত্ৰিত কৰে।",
    "gui.device.esp8266NodeMCU.description":
        "কম খৰচৰ Wi-Fi SOC নিয়ন্ত্ৰণ বৰ্ড।",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V চিপ ভিত্তিক এটা নিয়ন্ত্ৰণ বৰ্ড যাৰ কেৱল মৌলিক কাৰ্যসমূহ আছে আৰু সকলো IO পিন উলিয়াই দিয়া হৈছে।",
    "gui.device.k210Maixduino.description": "ESP32 থকা K210 RISC-V বৰ্ড।",
    "gui.device.raspberryPiPicoIconURL.description":
        "আপোনাৰ ইলেক্ট্ৰনিক্স ধাৰণাসমূহক জীৱন্ত কৰি তোলা এটা বন্ধুত্বপূৰ্ণ, ব্যৱহাৰ কৰাত সহজ মাইক্ৰ'কণ্ট্ৰলাৰ বৰ্ড।",
    "gui.device.raspberryPiPicoWIconURL.description":
        "ৱায়াৰলেছ আৰু IoT প্ৰকল্পসমূহৰ বাবে নিখুঁত বিল্ট-ইন 2.4 GHz Wi-Fi আৰু Bluetooth 5.2 থকা Pico।",
    "gui.device.raspberryPiPico2IconURL.description":
        "জটিল এপ্লিকেশ্বনসমূহৰ বাবে পৰ্যাপ্ত RAM আৰু ফ্লেশ্বৰ সৈতে উচ্চ-প্ৰদৰ্শন ডুৱেল-ক'ৰ MCU।",
    "gui.device.raspberryPiPico2WIconURL.description":
        "নিৰ্বিঘ্ন ৱায়াৰলেছ IoT আৰু স্মাৰ্ট-হ'ম একত্ৰীকৰণৰ বাবে বিল্ট-ইন 2.4 GHz Wi-Fi আৰু Bluetooth।",
    "gui.device.microbit.description":
        "ডিজিটেল দক্ষতা শিক্ষা ৰূপান্তৰিত কৰা প'কেট-আকাৰৰ কম্পিউটাৰ।",
    "gui.device.microbitV2.description":
        "আপগ্ৰেড কৰা প্ৰচেছৰ, বিল্ট-ইন স্পীকাৰ আৰু মাইক্ৰ'ফ'ন, স্পৰ্শ সংবেদনশীল ল'গ'।",
    "gui.device.makeymakey.description": "যিকোনো বস্তুক এটা চাবিত পৰিণত কৰক।",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT হৈছে ESP32-S3 ভিত্তিক ব'ৰ্ড য'ত Wi-Fi, Bluetooth আৰু ৰ'বটিক্স আৰু IoT প্ৰকল্পৰ বাবে সমৃদ্ধ পেৰিফেৰেল আছে।",
    "gui.device.lightWingDrone.description":
        "লাইট উইং ড্ৰ'ন হৈছে উন্নত স্থিৰীকৰণ আৰু Wi-Fi নিয়ন্ত্ৰণ থকা উচ্চ-প্ৰদৰ্শনৰ ESP32-S3 ভিত্তিক ফ্লাইট কণ্ট্ৰ'লাৰ।",
    "gui.device.roboticDog.description":
        "Robotic Dog হৈছে Arduino Nano দ্বাৰা চালিত এটা স্মাৰ্ট চতুৰ্পদ ৰ'বট, যি জীৱন্তসদৃশ গতি আৰু বাধা পৰিহাৰ কৰিবলৈ সক্ষম।",
    "gui.device.roboticArm.description":
        "Robotic Arm হৈছে Arduino Nano দ্বাৰা চালিত এটা মাল্টি-অক্ষ মেনিপুলেটৰ, যি নিখুঁত কাম আৰু অট'মেচন শিকাৰ বাবে ডিজাইন কৰা হৈছে।",
    // Music
    "music.categoryName": "সংগীত",
    "music.playDrumForBeats": "[DRUM] ড্ৰাম [BEATS] বিটৰ বাবে বজাওক",
    "music.restForBeats": "[BEATS] বিটৰ বাবে ৰওক",
    "music.playNoteForBeats": "[NOTE] নোট [BEATS] বিটৰ বাবে বজাওক",
    "music.setInstrument": "বাদ্যযন্ত্ৰ [INSTRUMENT] নিৰ্ধাৰণ কৰক",
    "music.changeTempo": "টেম্পো [TEMPO] দ্বাৰা সলনি কৰক",
    "music.setTempo": "টেম্পো [TEMPO] লৈ নিৰ্ধাৰণ কৰক",
    "music.getTempo": "টেম্পো",
    "music.drumBass": "(2) বাছ ড্ৰাম",
    "music.drumBongo": "(13) বংগো",
    "music.drumCabasa": "(15) কাবাছা",
    "music.drumClaves": "(9) ক্লেভছ",
    "music.drumClosedHiHat": "(6) বন্ধ হাই-হেট",
    "music.drumConga": "(14) কঙ্গা",
    "music.drumCowbell": "(11) কাউবেল",
    "music.drumCrashCymbal": "(4) ক্ৰেছ চিম্বল",
    "music.drumCuica": "(18) কুইকা",
    "music.drumGuiro": "(16) গুইৰো",
    "music.drumHandClap": "(8) হাতচাপৰি",
    "music.drumOpenHiHat": "(5) খোলা হাই-হেট",
    "music.drumSideStick": "(3) ছাইড ষ্টিক",
    "music.drumSnare": "(1) স্নেয়াৰ ড্ৰাম",
    "music.drumTambourine": "(7) খঞ্জৰী (Tambourine)",
    "music.drumTriangle": "(12) ট্ৰায়েংগল",
    "music.drumVibraslap": "(17) ভাইব্ৰাস্লেপ",
    "music.drumWoodBlock": "(10) উড ব্লক",
    "music.instrumentBass": "(6) বাছ",
    "music.instrumentBassoon": "(14) বাছুন",
    "music.instrumentCello": "(8) চেলো",
    "music.instrumentChoir": "(15) গায়ক দল",
    "music.instrumentClarinet": "(10) ক্লাৰিনেট",
    "music.instrumentElectricGuitar": "(5) ইলেকট্রিক গিটাৰ",
    "music.instrumentElectricPiano": "(2) ইলেকট্রিক পিয়ানো",
    "music.instrumentFlute": "(12) বাঁহী",
    "music.instrumentGuitar": "(4) গিটাৰ",
    "music.instrumentMarimba": "(19) মাৰিম্বা",
    "music.instrumentMusicBox": "(17) মিউজিক বক্স",
    "music.instrumentOrgan": "(3) অৰ্গেন",
    "music.instrumentPiano": "(1) পিয়ানো",
    "music.instrumentPizzicato": "(7) পিজিকাটো",
    "music.instrumentSaxophone": "(11) চেক্সোফোন",
    "music.instrumentSteelDrum": "(18) ষ্টীল ড্ৰাম",
    "music.instrumentSynthLead": "(20) চিন্থ লীড",
    "music.instrumentSynthPad": "(21) চিন্থ পেড",
    "music.instrumentTrombone": "(9) ট্ৰম্বোন",
    "music.instrumentVibraphone": "(16) ভাইব্রাফোন",
    "music.instrumentWoodenFlute": "(13) কাঠৰ বাঁহী",

    // Pen
    "pen.categoryName": "কলম",
    "pen.clear": "সকলো মুচি পেলাওক",
    "pen.stamp": "ষ্টাম্প",
    "pen.penDown": "কলম তললৈ",
    "pen.penUp": "কলম ওপৰলৈ",
    "pen.setColor": "কলমৰ ৰং [COLOR] নিৰ্ধাৰণ কৰক",
    "pen.changeSize": "কলমৰ আকাৰ [SIZE] দ্বাৰা সলনি কৰক",
    "pen.setSize": "কলমৰ আকাৰ [SIZE] লৈ নিৰ্ধাৰণ কৰক",
    "pen.colorMenu.color": "ৰং",
    "pen.colorMenu.saturation": "সংপৃক্ততা (saturation)",
    "pen.colorMenu.brightness": "উজ্জ্বলতা (brightness)",
    "pen.colorMenu.transparency": "স্বচ্ছতা",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "সংগীত",
    "gui.extension.music.description": "বাদ্যযন্ত্ৰ আৰু ড্ৰাম বজায়ক।",
    "gui.extension.pen.name": "পেন",
    "gui.extension.pen.description": "আপোনাৰ স্প্ৰাইটৰ সৈতে ছবি আঁকক।",
    "gui.extension.videosensing.name": "ভিডিঅ' চেঞ্চিং",
    "gui.extension.videosensing.description": "কেমেৰাৰ সৈতে গতি অনুভৱ কৰক।",
    "gui.extension.poseface.name": "ফেচ চেঞ্চিং",
    "gui.extension.poseface.description":
        "কেমেৰাৰ সৈতে মুখৰ অংগ সঞ্চালন অনুভৱ কৰক।",
    "gui.extension.posehand.name": "হেণ্ড চেঞ্চিং",
    "gui.extension.posehand.description": "কেমেৰাৰ সৈতে হাতৰ গতি অনুভৱ কৰক।",
    "gui.extension.posebody.name": "বডী পোজ চেঞ্চিং",
    "gui.extension.posebody.description": "কেমেৰাৰ সৈতে শৰীৰৰ গতি অনুভৱ কৰক।",
    "gui.extension.teachablemachine.name": "টিচেবল মেচিন",
    "gui.extension.teachablemachine.description":
        "আপোনাৰ কেমেৰাৰ সৈতে কাষ্টম মেচিন লাৰ্নিং মডেল ব্যৱহাৰ কৰক।",
    "gui.extension.text2speech.name": "টেক্সট টু স্পীচ",
    "gui.extension.text2speech.description": "আপোনাৰ প্ৰকল্পটোক কথা কোৱাওক।",
    "gui.extension.translate.name": "অনুবাদ",
    "gui.extension.translate.description": "পাঠক বিভিন্ন ভাষালৈ অনুবাদ কৰক।",
    "gui.extension.makeymakey.name": "মেকৰ মেকৰ",
    "gui.extension.makeymakey.description":
        "যিকোনো বস্তুক এটা চাবিত পৰিণত কৰক।",

    // Arduino Translations
    "arduinoUno.category.pins": "পিন",
    "arduinoUno.category.serial": "চিৰিয়েল",
    "arduinoUno.category.data": "ডাটা",

    "arduinoNano.category.pins": "পিন",
    "arduinoNano.category.serial": "চিৰিয়েল",
    "arduinoNano.category.data": "ডাটা",

    "arduinoLeonardo.category.pins": "পিন",
    "arduinoLeonardo.category.serial": "চিৰিয়েল",
    "arduinoLeonardo.category.data": "ডাটা",

    "arduinoMega2560.category.pins": "পিন",
    "arduinoMega2560.category.serial": "চিৰিয়েল",
    "arduinoMega2560.category.data": "ডাটা",

    "arduinoEsp32.category.pins": "পিন",
    "arduinoEsp32.category.serial": "চিৰিয়েল",
    "arduinoEsp32.category.data": "ডাটা",

    "arduinoEsp8266.category.pins": "পিন",
    "arduinoEsp8266.category.serial": "চিৰিয়েল",
    "arduinoEsp8266.category.data": "ডাটা",

    "arduinoK210.category.pins": "পিন",
    "arduinoK210.category.serial": "চিৰিয়েল",
    "arduinoK210.category.data": "ডাটা",

    "arduinoRaspberryPiPico.category.pins": "পিন",
    "arduinoRaspberryPiPico.category.serial": "চিৰিয়েল",
    "arduinoRaspberryPiPico.category.data": "ডাটা",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "ইনপুট",
    "arduinoUno.modeMenu.output": "আউটপুট",
    "arduinoUno.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoUno.levelMenu.high": "হাই (High)",
    "arduinoUno.levelMenu.low": "লো (Low)",
    "arduinoUno.pins.setPinMode": "পিন [PIN] মোড [MODE] চেট কৰক",
    "arduinoUno.pins.setDigitalOutput": "ডিজিটেল পিন [PIN] আউট [LEVEL] চেট কৰক",
    "arduinoUno.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoUno.pins.readDigitalPin": "ডিজিটেল পিন [PIN] পঢ়ক",
    "arduinoUno.pins.readAnalogPin": "এনালগ পিন [PIN] পঢ়ক",
    "arduinoUno.pins.setServoOutput": "চাৰ্ভো পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoUno.pins.attachInterrupt":
        "ইন্টাৰাপ্ট পিন [PIN] মোড [MODE] যোগ কৰক",
    "arduinoUno.pins.detachInterrupt": "ইন্টাৰাপ্ট পিন [PIN] পৃথক কৰক",
    "arduinoUno.serial.serialBegin": "চিৰিয়েল আৰম্ভ বডৰেট [VALUE]",
    "arduinoUno.serial.serialPrint": "চৰিয়েল প্ৰিন্ট [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "চিৰিয়েল উপলব্ধ ডাটা দৈৰ্ঘ্য",
    "arduinoUno.serial.serialReadAByte": "চিৰিয়েল এটা বাইট পঢ়ক",
    "arduinoUno.data.dataMap":
        "[DATA] ক ([ARG0], [ARG1]) ৰ পৰা ([ARG2], [ARG3]) লৈ মেপ কৰক",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "ইনপুট",
    "arduinoNano.modeMenu.output": "আউটপুট",
    "arduinoNano.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoNano.levelMenu.high": "হাই (High)",
    "arduinoNano.levelMenu.low": "লো (Low)",
    "arduinoNano.pins.setPinMode": "পিন [PIN] মোড [MODE] চেট কৰক",
    "arduinoNano.pins.setDigitalOutput":
        "ডিজিটেল পিন [PIN] আউট [LEVEL] চেট কৰক",
    "arduinoNano.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoNano.pins.readDigitalPin": "ডিজিটেল পিন [PIN] পঢ়ক",
    "arduinoNano.pins.readAnalogPin": "এনালগ পিন [PIN] পঢ়ক",
    "arduinoNano.pins.setServoOutput": "চাৰ্ভো পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoNano.pins.attachInterrupt":
        "ইন্টাৰাপ্ট পিন [PIN] মোড [MODE] যোগ কৰক",
    "arduinoNano.pins.detachInterrupt": "ইন্টাৰাপ্ট পিন [PIN] পৃথক কৰক",
    "arduinoNano.serial.serialBegin": "চিৰিয়েল আৰম্ভ বডৰেট [VALUE]",
    "arduinoNano.serial.serialPrint": "চৰিয়েল প্ৰিন্ট [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "চিৰিয়েল উপলব্ধ ডাটা দৈৰ্ঘ্য",
    "arduinoNano.serial.serialReadAByte": "চিৰিয়েল এটা বাইট পঢ়ক",
    "arduinoNano.data.dataMap":
        "[DATA] ক ([ARG0], [ARG1]) ৰ পৰা ([ARG2], [ARG3]) লৈ মেপ কৰক",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "ইনপুট",
    "arduinoLeonardo.modeMenu.output": "আউটপুট",
    "arduinoLeonardo.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoLeonardo.levelMenu.high": "হাই (High)",
    "arduinoLeonardo.levelMenu.low": "লো (Low)",
    "arduinoLeonardo.pins.setPinMode": "পিন [PIN] মোড [MODE] চেট কৰক",
    "arduinoLeonardo.pins.setDigitalOutput":
        "ডিজিটেল পিন [PIN] আউট [LEVEL] চেট কৰক",
    "arduinoLeonardo.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoLeonardo.pins.readDigitalPin": "ডিজিটেল পিন [PIN] পঢ়ক",
    "arduinoLeonardo.pins.readAnalogPin": "এনালগ পিন [PIN] পঢ়ক",
    "arduinoLeonardo.pins.setServoOutput": "চাৰ্ভো পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoLeonardo.pins.attachInterrupt":
        "ইন্টাৰাপ্ট পিন [PIN] মোড [MODE] যোগ কৰক",
    "arduinoLeonardo.pins.detachInterrupt": "ইন্টাৰাপ্ট পিন [PIN] পৃথক কৰক",
    "arduinoLeonardo.serial.serialBegin": "চিৰিয়েল আৰম্ভ বডৰেট [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "চৰিয়েল প্ৰিন্ট [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "চিৰিয়েল উপলব্ধ ডাটা দৈৰ্ঘ্য",
    "arduinoLeonardo.serial.serialReadAByte": "চিৰিয়েল এটা বাইট পঢ়ক",
    "arduinoLeonardo.data.dataMap":
        "[DATA] ক ([ARG0], [ARG1]) ৰ পৰা ([ARG2], [ARG3]) লৈ মেপ কৰক",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "ইনপুট",
    "arduinoMega2560.modeMenu.output": "আউটপুট",
    "arduinoMega2560.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoMega2560.levelMenu.high": "হাই (High)",
    "arduinoMega2560.levelMenu.low": "লো (Low)",
    "arduinoMega2560.pins.setPinMode": "পিন [PIN] মোড [MODE] চেট কৰক",
    "arduinoMega2560.pins.setDigitalOutput":
        "ডিজিটেল পিন [PIN] আউট [LEVEL] চেট কৰক",
    "arduinoMega2560.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoMega2560.pins.readDigitalPin": "ডিজিটেল পিন [PIN] পঢ়ক",
    "arduinoMega2560.pins.readAnalogPin": "এনালগ পিন [PIN] পঢ়ক",
    "arduinoMega2560.pins.setServoOutput": "চাৰ্ভো পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoMega2560.pins.attachInterrupt":
        "ইন্টাৰাপ্ট পিন [PIN] মোড [MODE] যোগ কৰক",
    "arduinoMega2560.pins.detachInterrupt": "ইন্টাৰাপ্ট পিন [PIN] পৃথক কৰক",
    "arduinoMega2560.serial.serialBegin": "চিৰিয়েল আৰম্ভ বডৰেট [VALUE]",
    "arduinoMega2560.serial.serialPrint": "চৰিয়েল প্ৰিন্ট [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "চিৰিয়েল উপলব্ধ ডাটা দৈৰ্ঘ্য",
    "arduinoMega2560.serial.serialReadAByte": "চিৰিয়েল এটা বাইট পঢ়ক",
    "arduinoMega2560.data.dataMap":
        "[DATA] ক ([ARG0], [ARG1]) ৰ পৰা ([ARG2], [ARG3]) লৈ মেপ কৰক",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "ইনপুট",
    "arduinoEsp32.modeMenu.output": "আউটপুট",
    "arduinoEsp32.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoEsp32.levelMenu.high": "হাই (High)",
    "arduinoEsp32.levelMenu.low": "লো (Low)",
    "arduinoEsp32.pins.setPinMode": "পিন [PIN] মোড [MODE] চেট কৰক",
    "arduinoEsp32.pins.setDigitalOutput":
        "ডিজিটেল পিন [PIN] আউট [LEVEL] চেট কৰক",
    "arduinoEsp32.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoEsp32.pins.readDigitalPin": "ডিজিটেল পিন [PIN] পঢ়ক",
    "arduinoEsp32.pins.readAnalogPin": "এনালগ পিন [PIN] পঢ়ক",
    "arduinoEsp32.pins.setServoOutput": "চাৰ্ভো পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoEsp32.pins.attachInterrupt":
        "ইন্টাৰাপ্ট পিন [PIN] মোড [MODE] যোগ কৰক",
    "arduinoEsp32.pins.detachInterrupt": "ইন্টাৰাপ্ট পিন [PIN] পৃথক কৰক",
    "arduinoEsp32.serial.serialBegin": "চিৰিয়েল আৰম্ভ বডৰেট [VALUE]",
    "arduinoEsp32.serial.serialPrint": "চৰিয়েল প্ৰিন্ট [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "চিৰিয়েল উপলব্ধ ডাটা দৈৰ্ঘ্য",
    "arduinoEsp32.serial.serialReadAByte": "চিৰিয়েল এটা বাইট পঢ়ক",
    "arduinoEsp32.data.dataMap":
        "[DATA] ক ([ARG0], [ARG1]) ৰ পৰা ([ARG2], [ARG3]) লৈ মেপ কৰক",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "ইনপুট",
    "arduinoEsp8266.modeMenu.output": "আউটপুট",
    "arduinoEsp8266.modeMenu.inputPullup": "ইনপুট-পুলআপ",
    "arduinoEsp8266.levelMenu.high": "হাই (High)",
    "arduinoEsp8266.levelMenu.low": "লো (Low)",
    "arduinoEsp8266.pins.setPinMode": "পিন [PIN] মোড [MODE] চেট কৰক",
    "arduinoEsp8266.pins.setDigitalOutput":
        "ডিজিটেল পিন [PIN] আউট [LEVEL] চেট কৰক",
    "arduinoEsp8266.pins.setPwmOutput": "PWM পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoEsp8266.pins.readDigitalPin": "ডিজিটেল পিন [PIN] পঢ়ক",
    "arduinoEsp8266.pins.readAnalogPin": "এনালগ পিন [PIN] পঢ়ক",
    "arduinoEsp8266.pins.setServoOutput": "চাৰ্ভো পিন [PIN] আউট [OUT] চেট কৰক",
    "arduinoEsp8266.pins.attachInterrupt":
        "ইন্টাৰাপ্ট পিন [PIN] মোড [MODE] যোগ কৰক",
    "arduinoEsp8266.pins.detachInterrupt": "ইন্টাৰাপ্ট পিন [PIN] পৃথক কৰক",
    "arduinoEsp8266.serial.serialBegin": "চিৰিয়েল আৰম্ভ বডৰেট [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "চৰিয়েল প্ৰিন্ট [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "চিৰিয়েল উপলব্ধ ডাটা দৈৰ্ঘ্য",
    "arduinoEsp8266.serial.serialReadAByte": "চিৰিয়েল এটা বাইট পঢ়ক",
    "arduinoEsp8266.data.dataMap":
        "[DATA] ক ([ARG0], [ARG1]) ৰ পৰা ([ARG2], [ARG3]) লৈ মেপ কৰক",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] ক ([ARG0], [ARG1]) ৰ মাজত সীমাৱদ্ধ কৰক",
    "arduinoUno.data.dataConvert": "[DATA] ক [TYPE] লৈ ৰূপান্তৰ কৰক",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] ক ASCII আখৰলৈ ৰূপান্তৰ কৰক",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] ক ASCII নম্বৰলৈ ৰূপান্তৰ কৰক",
    "arduinoUno.dataTypeMenu.integer": "পূৰ্ণসংখ্যা",
    "arduinoUno.dataTypeMenu.decimal": "দশমিক",
    "arduinoUno.dataTypeMenu.string": "ষ্ট্ৰিং",

    "arduinoNano.data.dataConstrain":
        "[DATA] ক ([ARG0], [ARG1]) ৰ মাজত সীমাৱদ্ধ কৰক",
    "arduinoNano.data.dataConvert": "[DATA] ক [TYPE] লৈ ৰূপান্তৰ কৰক",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] ক ASCII আখৰলৈ ৰূপান্তৰ কৰক",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] ক ASCII নম্বৰলৈ ৰূপান্তৰ কৰক",
    "arduinoNano.dataTypeMenu.integer": "পূৰ্ণসংখ্যা",
    "arduinoNano.dataTypeMenu.decimal": "দশমিক",
    "arduinoNano.dataTypeMenu.string": "ষ্ট্ৰিং",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] ক ([ARG0], [ARG1]) ৰ মাজত সীমাৱদ্ধ কৰক",
    "arduinoLeonardo.data.dataConvert": "[DATA] ক [TYPE] লৈ ৰূপান্তৰ কৰক",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] ক ASCII আখৰলৈ ৰূপান্তৰ কৰক",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] ক ASCII নম্বৰলৈ ৰূপান্তৰ কৰক",
    "arduinoLeonardo.dataTypeMenu.integer": "পূৰ্ণসংখ্যা",
    "arduinoLeonardo.dataTypeMenu.decimal": "দশমিক",
    "arduinoLeonardo.dataTypeMenu.string": "ষ্ট্ৰিং",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] ক ([ARG0], [ARG1]) ৰ মাজত সীমাৱদ্ধ কৰক",
    "arduinoMega2560.data.dataConvert": "[DATA] ক [TYPE] লৈ ৰূপান্তৰ কৰক",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] ক ASCII আখৰলৈ ৰূপান্তৰ কৰক",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] ক ASCII নম্বৰলৈ ৰূপান্তৰ কৰক",
    "arduinoMega2560.dataTypeMenu.integer": "পূৰ্ণসংখ্যা",
    "arduinoMega2560.dataTypeMenu.decimal": "দশমিক",
    "arduinoMega2560.dataTypeMenu.string": "ষ্ট্ৰিং",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] ক ([ARG0], [ARG1]) ৰ মাজত সীমাৱদ্ধ কৰক",
    "arduinoEsp32.data.dataConvert": "[DATA] ক [TYPE] লৈ ৰূপান্তৰ কৰক",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] ক ASCII আখৰলৈ ৰূপান্তৰ কৰক",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] ক ASCII নম্বৰলৈ ৰূপান্তৰ কৰক",
    "arduinoEsp32.dataTypeMenu.integer": "পূৰ্ণসংখ্যা",
    "arduinoEsp32.dataTypeMenu.decimal": "দশমিক",
    "arduinoEsp32.dataTypeMenu.string": "ষ্ট্ৰিং",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] ক ([ARG0], [ARG1]) ৰ মাজত সীমাৱদ্ধ কৰক",
    "arduinoEsp8266.data.dataConvert": "[DATA] ক [TYPE] লৈ ৰূপান্তৰ কৰক",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] ক ASCII আখৰলৈ ৰূপান্তৰ কৰক",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] ক ASCII নম্বৰলৈ ৰূপান্তৰ কৰক",
    "arduinoEsp8266.dataTypeMenu.integer": "পূৰ্ণসংখ্যা",
    "arduinoEsp8266.dataTypeMenu.decimal": "দশমিক",
    "arduinoEsp8266.dataTypeMenu.string": "ষ্ট্ৰিং",

    // Library manager & Board manager - Assamese
    "gui.librariesBoardsTab": "লাইব্ৰেৰীসমূহ",
    "gui.boardManagerTab": "বোর্ড মেনেজাৰ",
    
    
    "gui.boardManager.title": "বোৰ্ড মেনেজাৰ",
    "gui.boardManager.description":
        "আধিকাৰিক Arduino বোৰ্ড বিচাৰি আৰু ইনষ্টল কৰক।",
    "gui.boardManager.searchPlaceholder":
        "Arduino বোৰ্ড বিচাৰক (উদাহৰণ: esp32)",
    "gui.boardManager.search": "বিচাৰক",
    "gui.boardManager.searching": "বিচাৰি থকা হৈছে...",
    "gui.boardManager.advancedOptionsShow": "▶ উন্নত বিকল্প (কাষ্টম ইনষ্টল পথ)",
    "gui.boardManager.advancedOptionsHide": "▼ উন্নত বিকল্প লুকাওক",
    "gui.boardManager.recommended": "পৰামৰ্শিত",
    "gui.boardManager.installed": "ইনষ্টল কৰা হৈছে ({count})",
    "gui.boardManager.searchResults": "বিচাৰ ফলাফল {count}",
    "gui.boardManager.refresh": "↻ ৰিফ্ৰেছ",
    "gui.boardManager.refreshing": "↻ ৰিফ্ৰেছ হৈছে...",

    "gui.libraryManager.title": "লাইব্ৰেৰী মেনেজাৰ",
    "gui.libraryManager.description":
        "আধিকাৰিক Arduino লাইব্ৰেৰী বিচাৰি আৰু ইনষ্টল কৰক।",
    "gui.libraryManager.searchPlaceholder":
        "Arduino লাইব্ৰেৰী বিচাৰক (উদাহৰণ: Servo)",
    "gui.libraryManager.search": "বিচাৰক",
    "gui.libraryManager.searching": "বিচাৰি থকা হৈছে...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ উন্নত বিকল্প (কাষ্টম ইনষ্টল পথ)",
    "gui.libraryManager.advancedOptionsHide": "▼ উন্নত বিকল্প লুকাওক",
    "gui.libraryManager.recommended": "পৰামৰ্শিত",
    "gui.libraryManager.installed": "ইনষ্টল কৰা হৈছে ({count})",
    "gui.libraryManager.searchResults": "বিচাৰ ফলাফল {count}",
    "gui.libraryManager.refresh": "↻ ৰিফ্ৰেছ",
    "gui.libraryManager.refreshing": "↻ ৰিফ্ৰেছ হৈছে...",
    "gui.gui.librariesBoardsTab": "লাইব্ৰেৰীসমূহ",
    "gui.gui.boardsManagerTab": "বোৰ্ড মেনেজাৰ",
};

export default as;
